module.exports = __webpack_public_path__ + "static/media/roundshape.cc5dbc31.jpg";